import FlowerIcon from '@/assets/flower.svg?react';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import TitledCard from '@/components/ui/TitledCard';

import CheckboxGroupLineTypes, {
  LINE_TYPES_NAME,
} from '../components/CheckboxGroupLineTypes';
import RadioGroupPlotType, {
  PLOT_TYPE_NAME,
} from '../components/RadioGroupPlotType';
import SelectCoOwnersCount from '../components/SelectCoOwnersCount';
import type { LineType } from '../schema';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useLingui } from '@lingui/react';

const Step1PlotInfo = () => {
  const { i18n } = useLingui();
  const [parent] = useAutoAnimate({ duration: 200 });

  return (
    <TitledCard
      title={i18n.t('Informacje o działce')}
      className="p-[14px] md:p-6"
    >
      <div className="flex flex-col gap-3" ref={parent}>
        {/* Q1: Plot type — always visible */}
        <RadioGroupPlotType />

        {/* Q2: Line types — appears after plot type selected */}
        <ConditionalRender when={(val) => !!val[PLOT_TYPE_NAME]}>
          <CheckboxGroupLineTypes />

          {/* Q3: Co-owners — appears after line type selected */}
          <ConditionalRender
            when={(val) => (val[LINE_TYPES_NAME] as LineType[]).length > 0}
          >
            <SelectCoOwnersCount />
          </ConditionalRender>
        </ConditionalRender>

        <div className="flex items-center gap-2 rounded-md bg-gray-200 px-[14px] py-3 md:px-6">
          <FlowerIcon width={16} className="shrink-0 text-primary" />
          <p className="caption-large text-oxford-blue-300">
            {i18n.t('Dane zapisywane automatycznie')}
          </p>
        </div>
      </div>
    </TitledCard>
  );
};

export default Step1PlotInfo;
